<script setup lang="ts">
import {useProductStore} from '@/store/good';
import {storeToRefs} from 'pinia';
import GoodsClassList from '@/components/payment-view/goods-class-list.vue';

const productStore = useProductStore();
const { goods, classes } = storeToRefs(productStore);

const removeClass = (classNumber: number) => {
    productStore.removeClass(classNumber);
}
</script>

<template>
    <StfDivider/>
    <StfSubHeading class="mb-2">Selected Classes</StfSubHeading>
    <GoodsClassList :classes="classes" :goods="goods" deleteable @delete="removeClass"/>
</template>
